import React, {useContext, useState} from "react";
import {Container, Row, Col} from "react-bootstrap";
import {ActionPanelContextProvider} from "context/action";
import {SWIFT_WIRES_PANEL_ACTIVITIES_PAGE} from "./context/SwiftWiresContext";
import {SecurityContext} from "context/security";
import SwiftWiresActivitiesPanel from "./SwiftWiresActivitiesPanel";
import {SwiftWiresContext} from "./context";

export default function SwiftWiresPanel() {

    const {swiftWiresDisplayState,clearSwiftWiresSearchAndLoadHome} = useContext(SwiftWiresContext);
    const {resetFlagRight} = useContext(SecurityContext);

    if(resetFlagRight.current){
        resetFlagRight.current = false;
        clearSwiftWiresSearchAndLoadHome();
    }

    const currentComponent = function () {
            return <SwiftWiresActivitiesPanel/>
    }

    return(<>
        <Container fluid>
            <Row>
                <Col style={{padding:0}}>
                    {currentComponent()}
                </Col>
            </Row>
            <Row>
                <br/>
            </Row>
        </Container>
    </>);

}
